import { render } from "./TaxonomyAutocomplete.vue?vue&type=template&id=1000a8e9"
import script from "./TaxonomyAutocomplete.vue?vue&type=script&lang=js"
export * from "./TaxonomyAutocomplete.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__